import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Col, Form, Collapse, Row } from 'antd';
import { ContentCollapse } from './styles';
import { CustomSwitch } from '../../SelfScheduling/components/form/editScheduleBlocks/CustomSwitch';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

const ResourceManagementOptions = ({ form }) => {
  const { translate: t } = useDictionaryTranslation();
  const { Panel } = Collapse;
  const { accountModules } = useSelector((state) => ({
    accountModules: state.auth.accountModules,
  }));
  const administrateWorkflows = Form.useWatch('administrateWorkflows', form);

  return (
    <>
      <Col md={24}>
        <ContentCollapse>
          <Collapse defaultActiveKey={['1']} style={{ minWidth: '100%' }}>
            <Panel header={t('displayOptions')} key="1" style={{ width: '100%' }}>
              <Col md={24}>
                <Row>
                  <Col xs={12}>
                    <Form.Item name="canViewCustomers" label={t('canViewCustomers')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="canEditCustomers" label={t('canEditCustomers')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  {accountModules.finalCustomers ? (
                    <>
                      <Col xs={12}>
                        <Form.Item
                          name="canViewFinalCustomers"
                          label={t('canViewFinalCustomers')}
                          valuePropName="checked"
                        >
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={12}>
                        <Form.Item
                          name="canEditFinalCustomers"
                          label={t('canEditFinalCustomers')}
                          valuePropName="checked"
                        >
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}
                  <Col xs={12}>
                    <Form.Item
                      name="canViewServicesSummary"
                      label={t('canViewServicesSummary')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      name="canEditServicesSummary"
                      label={t('canEditServicesSummary')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="canViewIncidentNotes" label={t('canViewIncidentNotes')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      name="canCreateIncidentNotes"
                      label={t('canCreateIncidentNotes')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      name="canDeleteIncidentNotes"
                      label={t('canDeleteIncidentNotes')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>

                  {accountModules?.asset ? (
                    <>
                      <Col xs={12}>
                        <Form.Item name="canViewAssets" label={t('canViewAssets')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12}>
                        <Form.Item name="canEditAssets" label={t('canEditAssets')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}

                  <Col xs={12}>
                    <Form.Item name="canViewReviewForm" label={t('canViewReviewForm')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="canEditReviewForm" label={t('canEditReviewForm')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      name="canViewResourceTracking"
                      label={t('canViewResourceTracking')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item
                      name="canViewCalendar"
                      label={t('canViewCalendar')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item
                      name="canViewDashboard"
                      label={t('canViewDashboard')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item
                      name="canViewServicesHistory"
                      label={t('canViewServicesHistory')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item name="canChangeServiceStatus" label={t('infoServiceStatus')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Item name="canCancelServices" label={t('canCancelServices')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                  {accountModules?.advancedAvailability ? (
                    <Col xs={12} md={12}>
                      <Form.Item
                        name="administrateAdvancedAvailability"
                        label={t('administrateAdvancedAvailability')}
                        valuePropName="checked"
                      >
                        <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                      </Form.Item>
                    </Col>
                  ) : null}
                  {accountModules.surveys ? (
                    <Col xs={12} md={12}>
                      <Form.Item name="canViewSurveys" label={t('canSeeSurveyMenu')} valuePropName="checked">
                        <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                      </Form.Item>
                    </Col>
                  ) : null}

                  {accountModules.supportChat ? (
                    <Col xs={12} md={12}>
                      <Form.Item
                        name="administrateQuickAnswers"
                        label={t('administrateQuickAnswers')}
                        valuePropName="checked"
                      >
                        <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                      </Form.Item>
                    </Col>
                  ) : null}

                  {accountModules.electronicInvoicing ? (
                    <>
                      <Col xs={12} md={12}>
                        <Form.Item name="canViewBillingSettings" label={t('canViewBilling')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={12}>
                        <Form.Item
                          name="canCreateInvoices"
                          label={t('canViewAndCreateBilling')}
                          valuePropName="checked"
                        >
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={12}>
                        <Form.Item
                          name="canCreateCreditNotes"
                          label={t('canViewAndCreateCreditNotes')}
                          valuePropName="checked"
                        >
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={12}>
                        <Form.Item
                          name="canCreateAdjustmentNotes"
                          label={t('canViewAndCreateAdjustmentNotes')}
                          valuePropName="checked"
                        >
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}
                  {accountModules?.inventory ? (
                    <>
                      <Col xs={12} md={12}>
                        <Form.Item name="administrateInventory" label={t('canViewInventory')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={12}>
                        <Form.Item name="canConfigureInventory" label={t('canConfigureInventory')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                    </>
                  ) : null}
                  {accountModules?.workFlows ? (
                    <>
                      <Col xs={12} md={12}>
                        <Form.Item name="administrateWorkflows" label={t('administrateWorkflows')} valuePropName="checked">
                          <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                        </Form.Item>
                      </Col>
                      {administrateWorkflows ? (
                        <Col xs={12} md={12}>
                          <Form.Item name="seeAllWorkflows" label={t('seeAllWorkflows')} valuePropName="checked">
                            <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                          </Form.Item>
                        </Col>
                      ) : null}
                    </>
                  ) : null}
                  <Col xs={12} md={12}>
                    <Form.Item name="canViewCustomLists" label={t('canViewCustomLists')} valuePropName="checked">
                      <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Panel>
          </Collapse>
        </ContentCollapse>
      </Col>
    </>
  );
};

ResourceManagementOptions.propTypes = {
  form: PropTypes.object,
};

export default ResourceManagementOptions;
